import { COLORS } from "../../../../constants";
import { HALO } from "../../../../constants/colors";
/**
 * label styles
 */
export var inputLabelSxPropsFn = function (_a) {
    var sizeData = _a.sizeData;
    return ({
        fontSize: sizeData.fontSize,
        transform: "translate(14px, ".concat(sizeData.label, ") scale(1)"),
        "&.MuiInputLabel-shrink": {
            transform: "translate(14px, -9px) scale(0.75)",
            px: 1,
            bgcolor: COLORS.WHITE,
            borderRadius: 1,
        },
    });
};
/**
 * Input styles
 */
export var inputSxPropsFn = function (_a) {
    var sizeData = _a.sizeData, defaultAdornmentColors = _a.defaultAdornmentColors, multiline = _a.multiline, frontAdornment = _a.frontAdornment, disabled = _a.disabled;
    return ({
        "input::placeholder": {
            color: COLORS.P_MED_LOW_EMPHASIS,
            opacity: 1,
        },
        "input:focus-visible ~ .MuiOutlinedInput-notchedOutline, textarea:focus-visible ~ .MuiOutlinedInput-notchedOutline": {
            boxShadow: HALO,
            border: "none",
        },
        svg: {
            color: defaultAdornmentColors && !disabled ? COLORS.P_HIGH_EMPHASIS : undefined,
        },
        "&.Mui-focused": {
            "& svg": {
                color: defaultAdornmentColors && !disabled ? COLORS.P_MED_EMPHASIS : undefined,
            },
            ".MuiOutlinedInput-notchedOutline": {
                borderWidth: "1px",
                borderColor: COLORS.P_HIGH_EMPHASIS,
            },
        },
        ".MuiOutlinedInput-notchedOutline": {
            "& legend": {
                fontSize: sizeData.legend,
            },
        },
        "&.MuiOutlinedInput-root": {
            "&.MuiInputBase-multiline": {
                px: 0,
                py: 2.25,
            },
            "&:focus-visible": {},
            "& fieldset": {
                borderColor: COLORS.P_OUTLINE,
            },
            "&:hover .MuiOutlinedInput-notchedOutline": {
                borderColor: COLORS.P_HIGH_EMPHASIS,
            },
            "&.MuiInputBase-adornedEnd": {
                pr: 3,
                ".MuiInputAdornment-positionEnd": {
                    ml: 5,
                },
            },
        },
        // autocomplete tries overriding these
        ".MuiInputBase-input.MuiInputBase-input.MuiInputBase-input": {
            paddingTop: multiline ? 0 : sizeData.padding,
            paddingBottom: multiline ? 0 : sizeData.padding,
            paddingLeft: frontAdornment ? 0 : 4,
            fontSize: sizeData.fontSize,
            height: multiline ? undefined : sizeData.lineHeight,
        },
        borderRadius: "8px",
    });
};
